var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.channel)?_vm._t("default",null,{"channel":_vm.channel,"upsells":_vm.upsells,"selectedUpsell":_vm.selectedUpsell,"select":_vm.select,"isSingle":_vm.isSingle,"isSingleFree":_vm.isSingleFree}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }